import { createActions, createReducer } from 'reduxsauce'
import _ from 'lodash'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  success: false,
  loading: false,
  submitted: false,
  loaded: false,
  data: {},
  error: {},
  restaurantDetailsForETA: {},
  restaurantLocationMap: null,
  branchLoading: false,
  merchantsNote: {},

  startAt: null,
  endAt: null,
  branchOrders: {},
  branchOrderLoading: false,
})

const { Types, Creators } = createActions({
  fetchRestaurantsRequest: null,
  fetchRestaurantsConnected: ['data'],
  fetchRestaurantsError: ['error'],
  fetchRestaurantsDisconnected: null,

  fetchRestaurantRequest: ['id'],
  fetchRestaurantSuccess: ['restaurant'],
  fetchRestaurantError: ['error'],

  saveRestaurantRequest: ['key', 'params', 'callBack'],
  saveRestaurantSuccess: ['restaurant'],
  saveRestaurantError: ['error'],

  updateSubmittedStatus: ['status'],
  saveRestaurantDetailsForEta: ['restKey', 'resto'],

  deleteBranch: ['storeId', 'branch'],
  saveBranch: ['storeId', 'branchId', 'data', 'callBack'],
  setBranchLoading: ['val'],
  setBranchData: ['storeId', 'branchId', 'data'],
  setBranchDynamicFee: ['storeId', 'branchId', 'fee'],
  deleteBranchDynamicFee: ['storeId', 'branchId', 'fee'],

  getMerchantNote: ['merchantKey'],
  setMerchantNote: ['merchantKey', 'note'],

  setBranchOrderLoading: ['val'],
  setBranchOrders: ['data'],
  getBranchOrders: ['startAt', 'endAt'],
})

export const restaurantsRequest = state => state.set('loading', true)

export const restaurantsDisconnected = state => state.set('loading', false)

export const restaurantsConnected = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)
    .set('loaded', true)

export const restaurantsError = (state, { error }) => state.set('error', error).set('loading', false)

export const fetchRestaurantRequest = state => state.set('loading', true)

export const fetchRestaurantSuccess = (state, { restaurant }) =>
  state
    .setIn(['data', restaurant.key], restaurant)
    .set('success', true)
    .set('loading', false)

export const fetchRestaurantError = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const saveRestaurantRequest = state => state.set('submitted', true).set('loading', true)

export const saveRestaurantSuccess = (state, { restaurant }) =>
  state
    .setIn(['data', restaurant.key], restaurant)
    .set('success', true)
    .set('loading', false)

export const saveRestaurantError = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const updateSubmittedStatus = (state, { status }) => state.set('submitted', status)

export const saveRestaurantDetailsForETAReducer = (state, { restKey, resto }) =>
  state.setIn(['restaurantDetailsForETA', restKey], resto)

export const showRestaurantLocationReducer = (state, { restaurant }) =>
  state.set('restaurantLocationMap', restaurant)

export const deleteBranchReducer = (state, { storeId, branch }) =>
  state.setIn(['data', storeId, 'branches'], _.omit(state.data[storeId].branches, branch.key))

export const setBranchLoadingReducer = (state, { val }) => state.set('branchLoading', val)

export const setBranchDataReducer = (state, { storeId, branchId, data }) =>
  state.setIn(['data', storeId, 'branches', branchId], data)

export const setBranchDynamicFeeReducer = (state, { storeId, branchId, fee }) =>
  state.setIn(['data', storeId, 'branches', branchId, 'dynamic_fees', fee.key], fee.data)

export const deleteBranchDynamicFeeReducer = (state, { storeId, branchId, fee }) =>
  state.setIn(
    ['data', storeId, 'branches', branchId, 'dynamic_fees'],
    _.omit(state.data[storeId].branches[branchId].dynamic_fees || {}, fee.key)
  )

export const setMerchantNoteReducer = (state, { merchantKey, note }) =>
  state.setIn(['merchantsNote', merchantKey], note)

export const setbranchOrdersReducer = (state, { data }) => state.set('branchOrders', data)

export const getBranchOrdersReducer = (state, { startAt, endAt }) =>
  state.set('startAt', startAt).set('endAt', endAt)

export const setBranchOrderLoadingReducer = (state, { val }) => state.set('branchOrderLoading', val)

export const restaurantReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_RESTAURANTS_REQUEST]: restaurantsRequest,
  [Types.FETCH_RESTAURANTS_CONNECTED]: restaurantsConnected,
  [Types.FETCH_RESTAURANTS_DISCONNECTED]: restaurantsDisconnected,
  [Types.FETCH_RESTAURANTS_ERROR]: restaurantsError,

  [Types.FETCH_RESTAURANT_REQUEST]: fetchRestaurantRequest,
  [Types.FETCH_RESTAURANT_SUCCESS]: fetchRestaurantSuccess,
  [Types.FETCH_RESTAURANT_ERROR]: fetchRestaurantError,

  [Types.SAVE_RESTAURANT_REQUEST]: saveRestaurantRequest,
  [Types.SAVE_RESTAURANT_SUCCESS]: saveRestaurantSuccess,
  [Types.SAVE_RESTAURANT_ERROR]: saveRestaurantError,

  [Types.UPDATE_SUBMITTED_STATUS]: updateSubmittedStatus,
  [Types.SAVE_RESTAURANT_DETAILS_FOR_ETA]: saveRestaurantDetailsForETAReducer,

  [Types.DELETE_BRANCH]: deleteBranchReducer,
  [Types.SET_BRANCH_LOADING]: setBranchLoadingReducer,
  [Types.SET_BRANCH_DATA]: setBranchDataReducer,
  [Types.SET_BRANCH_DYNAMIC_FEE]: setBranchDynamicFeeReducer,
  [Types.DELETE_BRANCH_DYNAMIC_FEE]: deleteBranchDynamicFeeReducer,

  [Types.SET_MERCHANT_NOTE]: setMerchantNoteReducer,

  [Types.SET_BRANCH_ORDERS]: setbranchOrdersReducer,
  [Types.SET_BRANCH_ORDER_LOADING]: setBranchOrderLoadingReducer,
  [Types.GET_BRANCH_ORDERS]: getBranchOrdersReducer,
})

export const RestaurantTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/restaurantReducer.js